var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 11 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.125 22.25L10.875 11.5L0.125 0.75","fill":"white"}})])}
var staticRenderFns = []

export { render, staticRenderFns }